import React, { useEffect } from 'react'

//Dependencies.
import getVideoId from 'get-video-id'
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import './Video.styles.css'

const Video = ({ source, link }) => {
  const navigate = useNavigate();

  if (source === "YouTube") {
    const { id } = getVideoId(link);

    if (id) {
      return <iframe width="100%" height="250px" src={`https://www.youtube.com/embed/${id}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
    } else {
      return <iframe width="100%" height="250px" src="https://www.youtube.com/embed/ayf1sYiNLhQ?si=jKm6WU0Jp5DI70N1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    }

  } else if (source === "computer") {
    return (
      <video height='250px' style={{minWidth: '100%'}} controls>
        <source src={link} type='video/mp4' />
        <source src={link} type='video/ogg' />
        <source src={link} type='video/webm' />
        <strong><em>Sorry...</em> This video type is not supported. Try uploading this on You-Tube and try again.</strong>
      </video>
    )
  } else if (!source || !link) {
    navigate("/");

    alert(`Either your source (${source}) or your link (${link}) is invalid. Both props are REQUIRED!!!`);
    return;
  } else {
    navigate("/");

    alert(`Either your source (${source}) or your link (${link}) is invalid. Both props are REQUIRED!!!`);

    return;
  }
}

Video.propTypes = {
  source: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
}

export default Video